import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-owner-change',
    templateUrl: './dialog-owner-change.component.html',
    styleUrls: ['./dialog-owner-change.component.scss'],
    standalone: false
})
export class DialogOwnerChange implements OnInit {

    public owners: any[];
    public ownerId: number;
    public dashboardName: string;

    constructor(public dialogRef: MatDialogRef<DialogOwnerChange>, @Inject(MAT_DIALOG_DATA) public data: any, ) { }

    ngOnInit(): void {
        this.owners = this.data.owners;
        this.ownerId = this.data.owners.find(o => o.name === this.data.dashboardInfo.ownerName).userId;
        this.dashboardName = this.data.dashboardInfo.name;
    }

    onCancel() {
        this.dialogRef.close();
    }

    onConfirm() {  
        let ownerName = this.owners.find(o => o.userId === this.ownerId).name;
        this.dialogRef.close({ ownerId: this.ownerId, owner: ownerName});
    }

    isApplyDisabled() {
        if (!this.ownerId) return true;
        return false;
    }
}


